export const performAtomicVersionUpgrade = async ({ previous, createVersion, archive, }) => {
    let newResource;
    try {
        newResource = await createVersion();
    }
    catch (error) {
        // Create failed before anything changed — nothing to roll back.
        return { outcome: 'create_failed', error };
    }
    try {
        await archive(previous);
    }
    catch {
        // One retry — most archive failures are transient (network, rate limit).
        try {
            await archive(previous);
        }
        catch (retryError) {
            // Compensating archive: hide the newly-created version so the invariant
            // "at most one active resource per key" is preserved. If this also fails,
            // the client-side dedup still collapses the list, but surface the error
            // so the user knows nothing was kept.
            try {
                await archive(newResource);
            }
            catch {
                // Both archives failed; nothing more we can safely do here.
            }
            return { outcome: 'archive_failed', newResource, error: retryError };
        }
    }
    return { outcome: 'success', newResource };
};
